import React from "react";
import { Card, CardContent } from "../ui/card";

export default function StatCard({ label, value, tone = "default" }) {
  const accents = {
    default: "from-panel-ink/90 to-panel-ink/70",
    primary: "from-primary to-primary-hover",
    success: "from-emerald-500 to-emerald-600",
    info: "from-sky-500 to-indigo-500"
  };

  return (
    <Card className="overflow-hidden">
      <div className={`h-1.5 bg-gradient-to-r ${accents[tone] || accents.default}`} />
      <CardContent className="pt-5">
        <p className="text-sm font-medium text-panel-muted">{label}</p>
        <p className="mt-3 text-3xl font-extrabold text-panel-ink">{value}</p>
      </CardContent>
    </Card>
  );
}
